<section class="block">
    <header class="block-header">
        <h1 [translate]="'editInterviewPersonnelList'"></h1>
    </header>
    <ng-container>
        <ngx-datatable #grid
                       [rows]="gridItems"                       
                       [footerHeight]="'auto'"
                       [rowHeight]="'auto'"
                       [columnMode]="'force'"
                       [loadingIndicator]="gridLoading"
                       [externalSorting]="false"
                       [messages]="{ emptyMessage: 'gridEmpty' | translate, totalMessage: 'gridTotal' | translate }"
                       (sort)="onGridSort($event)">
            <ngx-datatable-column [name]="'interviewPersonnel_lblUser' | translate" prop="UserIdentity">
                <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex" let-value="row.UserIdentity">
                    <span *ngIf="!isGridEditing(row)">
                        {{value}}
                    </span>
                    <mat-form-field *ngIf="isGridEditing(row)">
                        <input matInput maxlength="93" style="text-align: right;"                         
                               name="UserIdentity"
                               [(ngModel)]="row.UserIdentity"/>
                        <span matSuffix>@rsu.lv</span>
                    </mat-form-field>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'interviewPersonnel_lblFullName' | translate" prop="FullName">
                <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex" let-value="row.FullName">
                    <span *ngIf="!isGridEditing(row)">
                        {{value}}
                    </span>
                    <mat-form-field *ngIf="isGridEditing(row)">
                        <input matInput
                               required maxlength="50"                            
                               name="FullName"
                               [(ngModel)]="row.FullName"/>
                    </mat-form-field>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'interviewPersonnel_lblPersonCode' | translate" prop="PersonCode">
                <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex" let-value="row.PersonCode">
                    <span *ngIf="!isGridEditing(row)">
                        {{value}}
                    </span>
                    <mat-form-field *ngIf="isGridEditing(row)">
                        <input matInput                               
                               name="PersonCode"
                               [(ngModel)]="row.PersonCode"
                               pattern="^[0-9]{6}-?[0-9]{5}$" maxlength="12" />
                    </mat-form-field>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [resizeable]="false">
                <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                    <button (click)="editGridRow(rowIndex)" class="btn-icon" *ngIf="!isGridEditing(row)" [title]="'edit' | translate">
                        <i class="fa fa-pencil"></i>
                    </button>
                    <button (click)="saveGridRow(rowIndex)"
                            class="btn-icon"
                            *ngIf="isGridEditing(row)"
                            [disabled]="!isValidGridItem(row)"
                            [title]="'save' | translate">
                        <i class="fa fa-floppy-o"></i>
                    </button>
                    <button (click)="cancelGridRow(rowIndex)" class="btn-icon" *ngIf="isGridEditing(row)" [title]="'cancel' | translate">
                        <i class="fa fa-ban"></i>
                    </button>
                    <button (click)="deleteGridRow(rowIndex)" class="btn-icon" *ngIf="!isNewGridItem(row)" [title]="'delete' | translate">
                        <i class="fa fa-trash"></i>
                    </button>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
        <div>
            <button mat-raised-button color="primary" (click)="addGridRow()">
                <i class="fa fa-plus"></i>
                {{'add' | translate}}
            </button>
        </div>
    </ng-container>
</section>